import { v4 as uuidv4 } from 'uuid'

export const orderTypes = [...new Array(5)].map((_: any, index: number) => ({
  id: uuidv4(),
  name: 'Order Type Code ' + ++index,
  __typename: 'OrderType'
}))
